const { Papa } = window;
Papa.SCRIPT_PATH = `${process.env.PUBLIC_URL}/papaparse.min.js`;

// eslint-disable-next-line import/prefer-default-export
export const generateNewDistribution = (hashedDistributionData, hashFile) => {
  const distributionMap = new Map(hashedDistributionData.map(i => [i.hash, i]));
  return new Promise((complete, error) => {
    Papa.parse(hashFile, {
      complete,
      error,
      worker: true,
      step: (row) => {
        const hash = row.data[0][0];
        distributionMap.delete(hash);
      },
    });
  }).then(() => {
    const outputData = Array.from(distributionMap.values());
    const blob = new Blob([Papa.unparse(outputData)], {
      type: 'application/csv;charset=utf-8;',
    });
    return new File([blob], 'distribution.csv');
  });
};
